/**
 * Async Thunk Declarations for Feed API
 *
 * @author Creator-Solutions -> Owen Burns
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFeeds } from "@/services/feed";
import {
  FeedResponseState,
  GetFeedInterface,
} from "@/interfaces/services/feed";

const getFeedThunk = createAsyncThunk("get", async (data: GetFeedInterface) => {
  const response = await getFeeds(data);

  if (!response.isError) {
    return {
      feedResponse: response.data,
    };
  } else {
    return {
      feedResponse: response.error,
    };
  }
});

export default {
  getFeedThunk,
};
